import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../toast/toast.component';
import { PoliticianService } from '../../../services/politician.service';
import { LegislatureService } from '../../../services/legislature.service';
import { GovernmentService } from '../../../services/government.service';
import { OrganizationService } from 'client/app/services/organization.service';
import { Politician } from '../../models/politician.model';
import {
  clusters, ee, emailRegexp, offices, officesNoPortfolio, officesOther,
  roles, rolesMedia, rolesOther, usernameRegexp
} from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-stakeholder-details-modal',
  templateUrl: './edit-stakeholder-details-modal.component.html',
  standalone: false
})
export class EditStakeholderDetailsModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private politicianService = inject(PoliticianService);
  private legislatureService = inject(LegislatureService);
  private governmentService = inject(GovernmentService);
  private organizationService = inject(OrganizationService);


  @Input() politician: Politician = {};
  @Input() field = '';

  clusters = clusters;
  offices = offices;
  officesNoPortfolio = officesNoPortfolio;
  officesOther = officesOther;
  roles = roles;
  rolesMedia = rolesMedia;
  rolesOther = rolesOther;
  usernameRegexp = usernameRegexp;
  emailRegexp = emailRegexp;
  governments = [];
  legislatures = [];
  politicianPartyId = { _id: '' };
  politicianPartyEuId = { _id: '' };
  politicianMediaId = { _id: '' };
  politicianOrganizationId = { _id: '' };
  partiesEu = [];
  parties = [];
  medias = [];
  orgs = [];
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditStakeholderDetailsModal', (field: string) => this.field = field);
    this.getGovernments();
    this.getLegislatures();
    this.getParties();
    this.getMedias();
    this.getOrganizations();
  }

  ngOnDestroy(): void {
    ee.off('showEditStakeholderDetailsModal', () => {});
  }

  getGovernments(): void {
    this.governmentService.getAll()
      .subscribe({
        next: res => this.governments = res,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getLegislatures(): void {
    this.legislatureService.getAll()
      .subscribe({
        next: res => this.legislatures = res,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getParties(): void {
    this.politicianService.getParties()
      .subscribe({
        next: res => {
          this.parties = res.filter(party => !party.parlamento_eu);
          this.partiesEu = res.filter(party => party.parlamento_eu);
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getMedias(): void {
    this.politicianService.getMedias()
      .subscribe({
        next: res => this.medias = res,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getOrganizations(): void {
    this.organizationService.search({})
      .subscribe({
        next: res => this.orgs = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  selectCluster(cluster: string): void {
    if (this.politician.topics.includes(cluster)) {
      const idx = this.politician.topics.indexOf(cluster);
      this.politician.topics.splice(idx, 1);
    } else {
      this.politician.topics.push(cluster);
    }
  }

  updatePolitician(field: string): void {
    const politician: Politician = {
      _id: this.politician._id,
      [field]: this.politician[field],
    };
    // Add fields if not already set
    if (field === '_party' && this.politicianPartyId._id) {
      politician[field] = this.politicianPartyId;
    }
    if (field === '_partyeu' && this.politicianPartyEuId._id) {
      politician[field] = this.politicianPartyEuId;
    }
    if (field === '_media' && this.politicianMediaId._id) {
      politician[field] = this.politicianMediaId;
    }
    if (field === '_organization' && this.politicianOrganizationId._id) {
      politician[field] = this.politicianOrganizationId;
    }
    this.politicianService.update(politician)
      .pipe(finalize(() => {
        this.resetPoliticianFieldIds();
        ee.emit('getPolitician');
      }))
      .subscribe({
        next: res => this.toast.setMessage('Stakeholder updated successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  resetPoliticianFieldIds(): void {
    this.politicianPartyId = { _id: '' };
    this.politicianPartyEuId = { _id: '' };
    this.politicianMediaId = { _id: '' };
    this.politicianOrganizationId = { _id: '' };
  }

}
